import Vue from 'vue';
import axios from 'axios';
import store from '@/store';

function storeCredentials(headers) {
  if (headers['access-token']) {
    localStorage.setItem('access-token', headers['access-token']);
  }
  localStorage.setItem('client', headers.client);
  localStorage.setItem('uid', headers.uid);
  localStorage.setItem('token-type', headers['token-type']);
}

axios.defaults.baseURL = process.env.API_BASE;

axios.interceptors.request.use((config) => {
  store.commit('alert/CLEAR');

  const c = config;
  c.headers.client = localStorage.getItem('client');
  c.headers['access-token'] = localStorage.getItem('access-token');
  c.headers.uid = localStorage.getItem('uid');
  c.headers['token-type'] = localStorage.getItem('token-type');

  return c;
}, error => Promise.reject(error));

axios.interceptors.response.use((response) => {
  if (response.headers.client) {
    storeCredentials(response.headers);
  }

  return response;
}, (error) => {
  if (error.response.headers.client) {
    storeCredentials(error.response.headers);
  }

  if (error.response.status === 401 && store.state.route.meta.auth) {
    if (store.state.auth.currentUser) {
      store.dispatch('auth/logout');
    }
    store.commit('redirect/ADD', store.state.route.path);
    Vue.router.push({ name: 'login' });
    store.commit('alert/ERROR', 'Unauthorized access');
  }
  return Promise.reject(error);
});

Vue.$http = axios;
Vue.prototype.$http = axios;



// WEBPACK FOOTER //
// ./src/plugins/axios.js